<template>
  <div class="job-board-details">
    <job-board-details-left-menu>
      <template slot="before">

        <nav-back-button to="/content/job-board">
          {{$t('jobBoard.details.menu.back')}}
        </nav-back-button>

        <card type="user"
              plain
              card-body-classes="px-0"
              footer-classes="p-0"
              class="mb-0 px-2"
              v-if="jobBoard">

          <div class="d-flex flex-column">
            <div class="d-flex text-overflow align-items-center">
              <base-avatar :src="jobBoard.logo" :name="jobBoard.name" :circle="false" size="sm" alt="User avatar"/>
              <div class="ml-2">
                <el-tooltip :content="$t('jobBoard.details.edit.name')" placement="top-start">
                  <div class="font-weight-bold mb-0 text-overflow">{{jobBoard.name}}</div>
                </el-tooltip>

                <div class="d-flex align-items-center text-overflow" v-if="jobBoardAdminUrl">
                  <a :href="jobBoardAdminUrl"
                     class="d-flex align-items-center"
                     target="_blank" rel="noopener">
                    <external-link-icon class="mr-1 external-link-icon"></external-link-icon>
                    <span class="pt-1">{{jobBoard.host}}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </card>
        <hr>

      </template>
    </job-board-details-left-menu>

    <div class="row">
      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import JobBoardService from 'src/services/JobBoardService'
  import { entities } from 'src/config/routeTypes'
  import { mapMutations, mapGetters } from 'vuex'
  import jobsModule from 'src/store/modules/jobs'
  import JobBoardDetailsLeftMenu from './JobBoardDetailsLeftMenu'
  import { ExternalLinkIcon } from 'vue-feather-icons'
  export default {
    name: 'job-board-details',
    components: {
      JobBoardDetailsLeftMenu,
      ExternalLinkIcon
    },
    data () {
      return {
        jobBoard: {},
        error: null,
        deleteActive: false,
      }
    },
    computed: {
      ...mapGetters('config', ['getJobBoardById']),
      jobBoardAdminUrl() {
        let token = localStorage.getItem('token')
        return `${this.jobBoard.url}?layout=editor&token=${token}`
      }
    },
    methods: {
      ...mapMutations('jobs', [jobsModule.types.SET_CURRENT_JOB_BOARD]),
      async deleteJobBoard () {
        await this.$confirm(this.$t('generic.delete.confirm', {
          title: this.jobBoard.name,
          entity: entities.JOB_BOARD
        }), {
          dangerouslyUseHTMLString: true
        })
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await JobBoardService.getById(id)
        let job = res.data
        if (job) {
          next(vm => {
            vm.jobBoard = job
            vm[jobsModule.types.SET_CURRENT_JOB_BOARD](job)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    },
  }
</script>q
<style lang="scss">
  .job-board-details {
    .job-board-image {
      width: 100px;
      height: 100%;
    }
    .job-board-link {
      font-size: $font-size-large;
    }
    .layout-margin {
      margin-top: 62px;
    }
  }
  .external-link-icon {
    width: 18px;
    height: 18px;
  }
</style>
